import balanceAdjustments from '@/locales/es/accounting/balanceAdjustments.locales';
import externalProviders from '@/locales/es/accounting/externalProviders.locales';
import payments from '@/locales/es/accounting/payments.locales';
import providerPayroll from '@/locales/es/accounting/providerPayroll.locales';

export default {
    ...balanceAdjustments,
    ...payments,
    ...externalProviders,
    ...providerPayroll,
};
